import React from 'react';
import { MinusOutlined, MinusCircleOutlined, MinusSquareOutlined } from '@ant-design/icons';

const sizeConfig = {
  small: {
    icon: <MinusOutlined style={{ color: '#4B9FFF' }} />,
  },
  mid: {
    icon: <MinusCircleOutlined style={{ color: '#FFA500' }} />,
  },
  big: {
    icon: <MinusSquareOutlined style={{ color: '#E5493A' }} />,
  },
};

export default sizeConfig;
